export default "__VITE_ASSET__d1bc1652__"